<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div role="tabpanel">
        <ul class="nav nav-tabs tabs" role="tablist">
          {{#each report}}
            <li role="presentation" class="tab {{#if @first}}active{{/if}}">
              <a href="#{{@key}}_pane" id="{{@key}}" role="tab" data-toggle="tab">{{@key}}</a>
            </li>
          {{/each}}
        </ul>
        <div class="tab-content">
          {{#each report}}
            <div role="tabpanel" class="tab-pane {{#if @first}}active{{/if}}" id="{{@key}}_pane">
              {{#each this}}
                <div class=row">
                  <div class="col-md-12">{{@key}}</div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <table class="table table-bordered table-striped table-condensed">
                      <tr>
                        <th>Page Key</th>
                        <th>Google Audit Pass Count</th>
                        <th>Google Audit Fail Count</th>
                        <th>AChecker Status</th>
                        <th>AChecker Error Count</th>
                        <th>AChecker Likely Error Count</th>
                        <th>AChecker Potential Error Count</th>
                      </tr>
                      {{#each this}}
                        <tr>
                          <td><a href="#{{@../../key}}/{{@../key}}/{{@key}}">{{@key}}</a></td>
                          <td>{{axsResults.passCount}}</td>
                          <td>{{axsResults.failCount}}</td>
                          <td>{{aCheckerResults.status}}</td>
                          <td>{{aCheckerResults.numOfErrors}}</td>
                          <td>{{aCheckerResults.numOfLikelyProblems}}</td>
                          <td>{{aCheckerResults.numOfPotentialProblems}}</td>
                        </tr>
                      {{/each}}
                    </table>
                  </div>
                </div>
              {{/each}}
            </div>
          {{/each}}
        </div>
      </div>
    </div>
  </div>
</div>
